import { ProductNames } from "../../constants/forecasts.constants";

export function isRatio(value: string): boolean {
  if (!value) {
    return false;
  }
  const productUppercase = value.toUpperCase();
  return (
    productUppercase !== ProductNames.OilPlusCond &&
    productUppercase !== ProductNames.Oil &&
    productUppercase !== ProductNames.Water &&
    productUppercase !== ProductNames.Gas &&
    productUppercase !== ProductNames.CondAbbreviated &&
    productUppercase !== ProductNames.CondAbbreviatedWithDot &&
    productUppercase !== ProductNames.Condensate &&
    productUppercase !== ProductNames.SalesGas &&
    productUppercase !== ProductNames.Steam
  );
}

/**
 * Check if a product is a declining ratio (CGR, OGR, WOR, GOR, WGR, OnePlusWOR, OilPlusWater).
 * These ratios can have linear decline over time (Qo -> Qi over Duration).
 * Other constants like Shrinkage, C2GR, C3GR, etc. remain flat.
 */
export function isDecliningRatio(value: string): boolean {
  if (!value) {
    return false;
  }
  const productUppercase = value.toUpperCase();
  return (
    productUppercase === ProductNames.CGR ||
    productUppercase === ProductNames.OGR ||
    productUppercase === ProductNames.WOR ||
    productUppercase === ProductNames.GOR ||
    productUppercase === ProductNames.WGR ||
    productUppercase === ProductNames.OnePlusWOR ||
    productUppercase === ProductNames.OilPlusWater ||
    productUppercase === ProductNames.SOR
  );
}

export function isPrimaryProduct(value: string): boolean {
  return !isRatio(value);
}
